import React, { useState, useEffect } from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoCloudUploadOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { setVehicle } from "../../redux/slices/addVehicleSlice";
import { RootState } from "../../redux/store";
import { base64StringToFile, fileToBase64 } from "../../utils/stringToBytes32";

const ExtraImages: React.FC = () => {
  const [imageInputs, setImageInputs] = useState<string[]>(["input1"]); // Track the list of input fields
  const [images, setImages] = useState<string[]>([]); // Track the list of uploaded images

  const gallery = useSelector(
    (state: RootState) => state.addVehicle.Vehicle[0]?.gallery
  );

  const dispatch = useDispatch();

  // Function to handle file input change
  const handleFileChange = async (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    event.preventDefault();
    if (!event.target.files?.length) return;
    const file = event.target.files?.[0];
    console.log(file);
    const imgStr = await fileToBase64(file);
    if (file) {
      setImages((prevImages) => [...prevImages, imgStr]);
      // Add a new input box if the current file input is the last one
      if (index === imageInputs.length - 1) {
        setImageInputs([...imageInputs, `input${imageInputs.length + 1}`]);
      }
    }

    // console.log(images, imageInputs);
  };
  const handleDelete = (index: number) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);

    // Remove the corresponding input box
    const newImageInputs = [...imageInputs];
    newImageInputs.splice(index, 1);
    setImageInputs(newImageInputs);
  };

  useEffect(() => {
    if (gallery?.length && images?.length) {
      dispatch(
        setVehicle({
          gallery: [...gallery, ...images],
        })
      );
    }
  }, [images]);

  useEffect(() => {
    if (gallery?.length > 6) {
      const extraImgs = gallery.slice(6);
      setImages(extraImgs);

      Array.from({ length: extraImgs.length }).forEach((_, index) => {
        setImageInputs((prev) => [...prev, `input${index + 1}`]);
      });
    }
  }, []);

  // console.log("........");

  return (
    <div className="flex gap-5 flex-wrap">
      {imageInputs.map((inputId, index) => (
        <div key={index}>
          {images[index] ? (
            <div
              className="w-[120px] h-[120px] lg:w-[200px] lg:h-[200px] relative"
              key={index}
            >
              <RiDeleteBin5Line
                onClick={() => handleDelete(index)}
                className="text-white text-[20px] cursor-pointer absolute right-0 m-2"
              />
              <img
                src={URL.createObjectURL(base64StringToFile(images[index]))}
                alt=""
                className=" object-cover h-full w-full"
              />
            </div>
          ) : (
            <div className="flex flex-col gap-2 border-2 border-dashed p-5 border-[#D0D5DD] rounded-xl w-[120px] h-[120px] lg:w-[200px] lg:h-[200px] justify-center items-center cursor-pointer ">
              <label
                htmlFor={inputId}
                className="flex flex-col gap-2 w-full justify-center items-center cursor-pointer"
              >
                <IoCloudUploadOutline size={25} color="#2ff77a" />

                <p className="text-white bg-midGreen rounded-xl p-3 flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center">
                  Add image
                </p>
              </label>
              <input
                type="file"
                accept="image/*"
                id={inputId}
                capture="environment"
                onChange={(event) => handleFileChange(index, event)}
                hidden
              />
            </div>
          )}
        </div>
      ))}
      {/* You can add a section to display uploaded images, handle errors, etc., as needed */}
    </div>
  );
};

export default ExtraImages;
